import PropTypes from "prop-types";
import {greyishBlue50} from "assets/jss/main";

const imageSize = "40px";
const borderRadius = "8px";

RetailerThumbnail.propTypes = {
    link: PropTypes.string,
    alt: PropTypes.string,
};

export default function RetailerThumbnail({link, alt}) {
    return (
        <div style={{width: imageSize, height: imageSize}}>
            <img
                style={{
                    borderRadius: borderRadius,
                    border: "1px solid " + greyishBlue50,
                    objectFit: "contain",
                }}
                width={imageSize}
                height={imageSize}
                src={link}
                alt={alt}
            />
        </div>
    );
}
